import { useEffect, useSyncExternalStore } from 'react'
import { GlobalSearchStateActions } from 'contexts/GlobalSearch/GlobalSearchState'
import type { GlobalSearchAction } from 'contexts/GlobalSearch/GlobalSearchState'
import { DATE_SEARCH_OPTION_IDS } from 'constants/search'
import { getPendingSelectDatesPromptSnapshot, setPendingSelectDatesPrompt, subscribePendingSelectDatesPrompt } from 'lib/search/pendingSelectDatesPromptStore'

export default function useConsumePendingSelectDatesPrompt(
  globalSearchDispatch: React.Dispatch<GlobalSearchAction>,
  vertical: App.SearchVertical,
) {
  const pendingSelectDatesPrompt = useSyncExternalStore(subscribePendingSelectDatesPrompt, getPendingSelectDatesPromptSnapshot, getPendingSelectDatesPromptSnapshot)

  useEffect(() => {
    if (!pendingSelectDatesPrompt || pendingSelectDatesPrompt.vertical !== vertical) return

    globalSearchDispatch({
      type: GlobalSearchStateActions.SET_SEARCH_ITEM,
      searchItem: {
        searchType: 'property',
        value: pendingSelectDatesPrompt.propertyId,
        format: { mainText: pendingSelectDatesPrompt.propertyName },
      },
    })
    globalSearchDispatch({ type: GlobalSearchStateActions.SET_DATE_SEARCH_OPTION, optionId: DATE_SEARCH_OPTION_IDS.SPECIFIC })
    setPendingSelectDatesPrompt(undefined)
  }, [pendingSelectDatesPrompt, globalSearchDispatch, vertical])
}
